import { Codepen, Camera } from "react-feather";
import { NavLink } from "react-router-dom";

import "../../assets/css/header.css";

import ROUTES from "../../routes/routes";
export const Header = () => {
  return (
    <nav>
      <ul>
        <li>
          <NavLink
            to={ROUTES.TOURISM}
            className={({ isActive }) =>
              isActive ? "active_link" : "inactive_link"
            }
          >
            <Camera size={22} className="mb-1" /> Turismo
          </NavLink>
        </li>
        <li>
          <NavLink
            to={ROUTES.PAYMENTS}
            className={({ isActive }) =>
              isActive ? "active_link" : "inactive_link"
            }
          >
            <Codepen size={22} className="mb-1" /> Servicios
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};
